import { render, staticRenderFns } from "./DetalhesGerenteRegional.vue?vue&type=template&id=d95bfb04&scoped=true&lang=pug"
import script from "./DetalhesGerenteRegional.vue?vue&type=script&lang=js"
export * from "./DetalhesGerenteRegional.vue?vue&type=script&lang=js"
import style0 from "./DetalhesGerenteRegional.vue?vue&type=style&index=0&id=d95bfb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95bfb04",
  null
  
)

export default component.exports